export const getCroppedImage = async (imgRef, crop) => {
  const image = imgRef.current;
  if (!image || !crop) {
    throw new Error('Crop canvas does not exist');
  }

  // This will size relative to the uploaded image
  // size. If you want to size according to what they
  // are looking at on screen, remove scaleX + scaleY
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;

  // @ts-ignore
  const offscreen = new OffscreenCanvas(
    crop.width * scaleX,
    crop.height * scaleY
  );


  const ctx = offscreen.getContext('2d');
  if (!ctx) {
    throw new Error('No 2d context');
  }

  ctx.imageSmoothingQuality = 'high';

  const cropX = crop.x * scaleX;
  const cropY = crop.y * scaleY;

  ctx.drawImage(
    imgRef.current,
    cropX,
    cropY,
    offscreen.width,
    offscreen.height,
    0,
    0,
    offscreen.width,
    offscreen.height
  );

  const blob = await offscreen.convertToBlob({
    type: 'image/jpeg',
    quality: 0.95
  });

  return blob;
};
